export default __webpack_public_path__ + "static/media/d12.e17b726d.jpg";